import { IMAGE_PATH } from "./Constants";
export const FilterData = [
    {
      category: "Programming Language",
      id: "ProgrammingLanguage",
      id_created: "#ProgrammingLanguage",
      icon: `${IMAGE_PATH}/ico4.png`,
      subcategories: [
        "Python",
        "Java",
        "JavaScript/ TypeScript",
        "PHP",
        "HTML/CSS",
        "Swift (iOS)",
        "Kotlin (Android)"
      ]
    },
    {
      category: "UX Designing",
      id: "UXDesigning",
      id_created: "#UXDesigning",
      icon: `${IMAGE_PATH}/ico8.png`,
      subcategories: [
        "Wireframing & Prototyping",
        "User Interface (UI) /User Experience (UX)"
      ]
    },
    {
      category: "Data Visualization",
      id: "DataVisualization",
      id_created: "#DataVisualization",
      icon: `${IMAGE_PATH}/data_visualization.png`,
      subcategories: [
        "Data Visualization (Tableau, Power BI)",
        "Data Analysis (Pandas, NumPy)"
      ]
    },
    {
      category: "Testing",
      id: "Testing",
      id_created: "#Testing",
      icon: `${IMAGE_PATH}/testing_icon.png`,
      subcategories: [
        "JUnit/ JMeter/ Postman (API testing)",
        "Unit Testing"
      ]
    },
    {
      category: "Development Tool",
      id: "DevelopmentTool",
      id_created: "#DevelopmentTool",
      icon: `${IMAGE_PATH}/dev_tool.png`,
      subcategories: ["DevOps",
        "XML/CSV/JSON conversion",
        "REST APIs",
        "Regex",
        "Alert Systems",
        "Email APIs"
      ]
    },
    {
      category: "Artificial Intelligence",
      id: "ArtificialIntelligence",
      id_created: "#ArtificialIntelligence",
      icon: `${IMAGE_PATH}/ico2.png`,
      subcategories: [
        "Natural Language Processing (NLP)",
        "AI Workflow Design",
        "Chatbot",
        "Data Cleaning",
        "ML",
        "Anomaly Detection"
      ]
    },
    {
      category: "Frameworks/Libraries",
      id: "FrameworksLibraries",
      id_created: "#FrameworksLibraries",
      icon: `${IMAGE_PATH}/libraries_icon.png`,
      subcategories: [
        "React.js",
        "Vue.js",
        "Node.js",
        "jQuery",
        "React Native",
        "Flutter"
      ]
    },
    {
      category: "Databases",
      id: "Databases",
      id_created: "#Databases",
      icon: `${IMAGE_PATH}/database_icon.png`,
      subcategories: ["MySQL", "PostgreSQL", "MongoDB"]
    }
  ];
  